import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RouterOutlet } from '@angular/router';
import { app } from '@microsoft/teams-js';
import { Subject, filter, takeUntil } from 'rxjs';

import { Common } from 'app/modules/_common/service';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports: [RouterOutlet, MatFormFieldModule, FormsModule, MatInputModule, MatButtonModule]
})
export class AppComponent implements OnDestroy
{
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _snackBar: MatSnackBar,
        private _changeDetectorRef: ChangeDetectorRef)
    {
        app.initialize().then(() => {
            app.getContext().then((context) => {
                //var hostClientType = context.app.host.clientType;
                //if(hostClientType != "web" && hostClientType != "desktop"){
                //}

                app.notifySuccess();

                this._changeDetectorRef.markForCheck();
            });
        }, (e) => {
            //console.warn(e);

            this._changeDetectorRef.markForCheck();
        });

        Common.snackBarMessage$
            .pipe(takeUntil(this._unsubscribeAll), filter((raw) => raw != null))
            .subscribe(data => {

                this._changeDetectorRef.markForCheck();

                this._snackBar.open(data.message, data.title, {
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    //duration: 60 * 1000,
                    panelClass: data.isError ? 'app-notification-error' : 'app-notification-success'
                });
            });
    }

    ngOnDestroy(): void
    {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
